import DataSource from 'devextreme/data/data_source';

export class BdsRouteSearchDialogModel {
    title?: string;
    actionText: string;
    dismissiveText?: string = 'Cancel';
    splc?: string;
}
